export default {
  header: {
    title: '注文完了',
    alt: '完了'
  },
  gratitudeMessage: 'ご注文ありがとうございました',
  orderNumber: '注文番号：',
  password: 'パスワード：',
  howToConfirmOrderContentMessage:
    '注文した内容は「注文確認」にてご確認いただけます。',
  completionMailSendNotice: '注文完了メールをお送り致しました。',
  completionMailNote1:
    '銀行振込の方は後日弊社からお送りする「請求書発行Eメール」にて',
  completionMailNote2: 'お振込先口座をご確認ください。',
  OrderContentConfirmation: '注文内容の確認',
  backToTop: 'TOPに戻る'
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/completion.js